const PAINTABLE_CHANNELS = new Set([
  'foundation',
  'surface',
  'outdoorFloor',
  'exterior',
  'interiorFloor',
]);

/** Whether a brush supports dragging, brush sizes, and area fill. */
export function supportsBrushTools(brush, tileCatalog) {
  if (brush.type === 'elevation') return true;
  if (brush.type === 'eraseTerrain' || brush.type === 'eraseObjects') return true;
  if (brush.type === 'eraseChannel') return PAINTABLE_CHANNELS.has(brush.channel);
  if (brush.type !== 'tile') return false;
  return PAINTABLE_CHANNELS.has(tileCatalog.get(brush.tileId)?.channel);
}

const DRAGGABLE_PALETTE_SECTIONS = new Set([
  'floraShrubs',
  'floraFlowers',
  'floraGrasses',
  'floraHedges',
  'fences',
]);

/** Whether holding and dragging should continuously apply a brush. */
export function supportsDragPainting(brush, tileCatalog) {
  if (supportsBrushTools(brush, tileCatalog)) return true;
  if (brush.type !== 'tile') return false;
  if (tileCatalog.get(brush.tileId)?.channel === 'roof') return false;
  return DRAGGABLE_PALETTE_SECTIONS.has(tileCatalog.get(brush.tileId)?.paletteSection);
}
